import { GalleryInfo } from "kreate-common/modules/business-types";

import { EM_DASH } from "@/modules/common-utils/unicode";

export function getPageTitle({
  galleryInfo,
  defaultTitle,
}: {
  galleryInfo: GalleryInfo | null | undefined;
  defaultTitle: string | null | undefined;
}) {
  return [galleryInfo?.title || defaultTitle || EM_DASH, "Kreate"].join(" | ");
}
